"use client";
import axios from "axios";
import React, { useState } from "react";
import OtpPopup from "./OtpPopup";
import joinImage from "../../assets/join.png";
import hiiSvg from "../../assets/hii.svg";

export default function JoinMentorsity() {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        message: "",
        profession: "student",
    });

    const [errors, setErrors] = useState({});
    const [showOtpPopup, setShowOtpPopup] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validationForm(formData);

        if (Object.keys(validationErrors).length === 0) {
            try {
                setShowOtpPopup(true);
            } catch (error) {
                console.error("Error during verification:", error);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    const validationForm = (data) => {
        const validationErrors = {};

        if (!data.fullName.trim()) {
            validationErrors.fullName = "Name is required";
        }

        if (!data.email.trim()) {
            validationErrors.email = "Email is required";
        } else if (!isValidEmail(data.email)) {
            validationErrors.email = "Invalid email format";
        }

        if (!data.phone.trim()) {
            validationErrors.phone = "Phone number is required";
        } else if (!isValidPhone(data.phone)) {
            validationErrors.phone = "Invalid phone number format";
        }

        return validationErrors;
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const isValidPhone = (phone) => {
        return /^\d{10}$/.test(phone);
    };

    return (
        <div className="my-8 sm:my-12 px-4 md:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
                <div className="flex flex-col md:flex-row items-start gap-8">
                    {/* Form Section */}
                    <div className="w-full md:w-1/2">
                        <div className="bg-gradient-to-br from-[#f8faff] to-[#f0f4ff] rounded-xl p-6 shadow-sm">
                            <div className="flex items-center gap-3 mb-6">
                                <div className="h-12 w-12 bg-[#04236B] rounded-full flex items-center justify-center">
                                    <img src={hiiSvg} alt="Hi" className="h-6 w-6" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-xl font-bold mr-10">
                                        <span className="text-[#04236B]">Join </span>
                                        <span className="text-[#F4B41A]">Mentor</span>
                                        <span className="text-[#04236B]">sity</span>
                                    </h2>
                                    <p className="text-gray-600 text-sm mr-6">Start your learning journey</p>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                {/* Full Name Field */}
                                <div>
                                    <div className="relative">
                                        <input
                                            className="w-full px-4 py-2.5 pl-10 bg-white/80 border border-gray-200/50 rounded-lg focus:ring-1 focus:ring-[#04236B]/30 focus:border-[#04236B]/30 transition-all duration-200 text-sm outline-none hover:border-[#04236B]/20"
                                            id="fullName"
                                            type="text"
                                            name="fullName"
                                            value={formData.fullName}
                                            onChange={handleChange}
                                            placeholder="Full Name"
                                        />
                                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                        </span>
                                    </div>
                                    {errors.fullName && (
                                        <p className="text-red-500 text-xs mt-1">{errors.fullName}</p>
                                    )}
                                </div>

                                {/* Email Field */}
                                <div>
                                    <div className="relative">
                                        <input
                                            className="w-full px-4 py-2.5 pl-10 bg-white/80 border border-gray-200/50 rounded-lg focus:ring-1 focus:ring-[#04236B]/30 focus:border-[#04236B]/30 transition-all duration-200 text-sm outline-none hover:border-[#04236B]/20"
                                            id="email"
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Email Address"
                                        />
                                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </span>
                                    </div>
                                    {errors.email && (
                                        <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                    )}
                                </div>

                                {/* Phone Field */}
                                <div>
                                    <div className="relative">
                                        <input
                                            className="w-full px-4 py-2.5 pl-10 bg-white/80 border border-gray-200/50 rounded-lg focus:ring-1 focus:ring-[#04236B]/30 focus:border-[#04236B]/30 transition-all duration-200 text-sm outline-none hover:border-[#04236B]/20"
                                            id="phone"
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="Phone Number"
                                        />
                                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                        </span>
                                    </div>
                                    {errors.phone && (
                                        <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
                                    )}
                                </div>

                                {/* Message Field */}
                                <div>
                                    <div className="relative">
                                        <textarea
                                            className="w-full px-4 py-2.5 pl-10 bg-white/80 border border-gray-200/50 rounded-lg focus:ring-1 focus:ring-[#04236B]/30 focus:border-[#04236B]/30 transition-all duration-200 text-sm outline-none resize-none hover:border-[#04236B]/20"
                                            id="message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            placeholder="Your learning goals"
                                            rows="3"
                                        />
                                        <span className="absolute left-3 top-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="pt-2 flex justify-center">
                                    <button
                                        className="bg-[#04236B] hover:bg-white hover:text-[#04236B] hover:border-[#04236B] text-white font-medium py-2.5 px-8 rounded-lg transition-all duration-300 text-sm inline-flex items-center gap-2 border-2 border-transparent"
                                        type="submit"
                                    >
                                        <span>Join Mentorsity</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Image Section */}
                    <div className="hidden md:block w-full md:w-1/2">
                        <div className="relative">
                            {/* Left Side Element */}
                            <div className="absolute left-0 top-1/4 -translate-y-1/2 -translate-x-6 z-10">
                                <div className="bg-white/90 backdrop-blur-sm p-3 rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 w-[160px]">
                                    <div className="flex items-center gap-2">
                                        <div className="h-8 w-8 bg-gradient-to-br from-[#04236B] to-[#04236B]/80 rounded-full flex items-center justify-center shadow-sm">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[#04236B] font-semibold text-xs">College Support</p>
                                            <p className="text-gray-600 text-[10px]">Admission Guide</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side Element */}
                            <div className="absolute right-0 top-1/4 -translate-y-1/2 translate-x-6 z-10">
                                <div className="bg-white/90 backdrop-blur-sm p-3 rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.16)] transition-all duration-300 w-[160px]">
                                    <div className="flex items-center gap-2">
                                        <div className="h-8 w-8 bg-gradient-to-br from-[#F4B41A] to-[#F4B41A]/80 rounded-full flex items-center justify-center shadow-sm">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[#04236B] font-semibold text-xs">Career Path</p>
                                            <p className="text-gray-600 text-[10px]">Future Guide</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Main Image */}
                            <div className="relative mt-[-20px] ml-4">
                                <img
                                    src={joinImage}
                                    alt="Join Mentorsity"
                                    className="h-auto max-w-full object-cover rounded-xl"
                                    style={{ maxHeight: '400px' }}
                                />
                                {/* Expert Mentors Box */}
                                <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 bg-white/95 backdrop-blur-sm p-4 rounded-lg shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 w-fit">
                                    <div className="flex items-center gap-4">
                                        <div className="h-12 w-12 bg-gradient-to-br from-[#F4B41A] to-[#F4B41A]/80 rounded-full flex items-center justify-center shadow-[0_4px_12px_rgb(244,180,26,0.3)]">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className="text-[#04236B] font-semibold text-sm">Expert Mentors</p>
                                            <p className="text-gray-600 text-xs">Learn from the best</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showOtpPopup && <OtpPopup setShowOtpPopup={setShowOtpPopup} email={formData.email} />}
        </div>
    );
}